/**
 * BCO Tracking status
 */
export enum Status {
    OK = 'OK',
    KOSI = 'KOSI',
    KORG = 'KORG',
    TO = 'TO',
}
